const input = document.getElementById("faq-search");
function faqproductSearch() {
  // Declare variables
  var filter, ul, li, a, i, txtValue;
  filter = input.value.toUpperCase();
  faqproduct = document.querySelectorAll(".products-search__wrapper");

  faqproduct.forEach((item) => {
    var li = item.querySelectorAll(".product__item");
    var txtValue =item.textContent || item.innerText;

    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      item.classList.remove('hide');
    } else {
      item.classList.add('hide');
    }

    // Loop through all list items, and hide those who don't match the search query
    for (i = 0; i < li.length; i++) {
       // title = li[i].querySelectorAll(".product__title")[0];
      txtValue = li[i].textContent || li[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
      
        li[i].classList.remove('hide');
      } else {
         li[i].classList.add('hide');
      }
    }
  });
}

input.addEventListener("keyup", function () {
  faqproductSearch();
});